import { render, staticRenderFns } from "./IcoSlider.vue?vue&type=template&id=1c85b43d"
import script from "./IcoSlider.vue?vue&type=script&lang=js"
export * from "./IcoSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports